import { api } from "./client";

export interface User {
  username: string;
  full_name: string | null;
}

/** POST /api/login → 200 + cookie | 401 invalid creds | 429 rate-limited */
export async function login(username: string, password: string): Promise<User> {
  const { data } = await api.post<User>("/api/login", { username, password });
  return data;
}

export async function logout(): Promise<void> {
  await api.post("/api/logout");
}

/** GET /api/me → 200 with current user or 401 */
export async function me(): Promise<User> {
  const { data } = await api.get<User>("/api/me");
  return data;
}
